module.exports = __webpack_public_path__ + "img/landing_bg_mobile.242009c8.png";